import { Box, styled } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';

import { colors } from '../theme/theme';

export const TextFieldWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    '& .MuiFormControl-root': {
        width: '100%',
        '& .MuiFormLabel-root': {
            ...theme.typography.body2,
            top: -4,
            '&.MuiInputLabel-shrink': {
                fontWeight: 400,
                lineHeight: 'normal',
                top: 1,
            },
            '&.Mui-focused': {
                color: colors.primaryLight[100],
            },
        },
        '& .MuiOutlinedInput-root': {
            ...theme.typography.body2,
            borderRadius: theme.spacing(1),
            [theme.breakpoints.down('md')]: {
                fontSize: 16,
            },
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderWidth: 1,
                },
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: colors.greyPreset[30],
            },
            '&:hover': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.primaryLight[100],
                },
            },
            '&.Mui-error': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.errorPreset[10],
                },
            },
            '&.Mui-disabled': {
                backgroundColor: colors.greyPreset[90],
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.greyPreset[30],
                },
                '& input': {
                    color: colors.greyPreset[10],
                    WebkitTextFillColor: `${colors.greyPreset[10]} !important`,
                    cursor: 'not-allowed',
                },
                '& .MuiInputAdornment-root': {
                    '& span, & svg, & .MuiIconButton-root': {
                        color: `${colors.greyPreset[10]} !important`,
                        cursor: 'not-allowed',
                    },
                },
            },
            '&.Mui-disabled.Mui-error': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.errorPreset[10],
                },
                '& input': {
                    color: colors.errorPreset[10],
                    WebkitTextFillColor: `${colors.errorPreset[10]} !important`,
                },
            },
        },
        '& .MuiInputBase-root': {
            backgroundColor: colors.fullWhite,
            position: 'relative',
            '&.MuiInputBase-colorSecondary': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.primaryLight[100],
                },
            },
            '& .MuiInputAdornment-root': {
                margin: 0,
                cursor: 'pointer',
            },
            '& input': {
                padding: theme.spacing(1.5),
                color: colors.fullBlack,
                '&::placeholder': {
                    color: theme.palette.text.secondary,
                    opacity: 1,
                },
                '&:-webkit-autofill': {
                    // WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.mode === 'dark' ? '#121212' : '#ffff'} inset`,
                    WebkitTextFillColor: `${colors.fullBlack} !important`,
                },
            },
        },
    },

    '& .textFieldTitle': {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    '& .helperTitle': {
        color: colors.bluePreset[30],
        marginTop: theme.spacing(0.5),
    },
    '& .errorTxt': {
        color: colors.errorPreset[10],
        marginTop: theme.spacing(0.5),
    },
    '& .phoneTextFiled': {
        '& .MuiInputBase-root': {
            '&.MuiOutlinedInput-root': {
                padding: '0px 12px',
            },
            '&.Mui-disabled': {
                backgroundColor: colors.greyPreset[90],
            },
        },
    },
    '& .searchTextFiled': {
        '& .MuiInputBase-root': {
            backgroundColor: colors.greyPreset[90],
        },
        '&.smallTextFiled': {
            '& .MuiInputBase-root': {
                '& input': {
                    padding: '6px 12px',
                },
            },
        },
    },
}));

export const TextAreaRoot = styled(TextareaAutosize)(({ theme }) => ({
    ...theme.typography.body2,
    width: '100%',
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    border: `1px solid ${colors.greyPreset[30]}`,
    fontFamily: theme.typography.fontFamily,
    resize: 'none',
    backgroundColor: colors.fullWhite,
    color: colors.fullBlack,
    [theme.breakpoints.down('md')]: {
        fontSize: 16,
    },
    '&:hover': {
        borderColor: colors.primaryLight[100],
    },
    '&:focus': {
        outline: 'none',
        borderColor: colors.primaryLight[100],
    },
    '&:disabled': {
        backgroundColor: colors.greyPreset[90],
        borderColor: colors.greyPreset[30],
        color: colors.greyPreset[10],
        WebkitTextFillColor: `${colors.greyPreset[10]} !important`,
        cursor: 'not-allowed',
    },
}));
